/*
 * @Author: wanglongx
 * @Date: 2019-08-12 09:48:47
 * @LastEditors: bbq
 * @LastEditTime: 2021-01-06 10:26:17
 * @Description: file content
 */
/*
*
* 跟Datepicker类似 是未转时区的日期组件  张横表格内需要的
*
* */

import React, { Component } from 'react';
import OriginDatePicker from 'bee-datepicker';
import moment from 'moment';
import { isArray } from 'util';
import { getDateFunNode, checkFuntionValue, getTimeFunctionLabel } from './dateFunction';
import { localeLang, locale, config } from '@platform/api';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import 'moment/locale/en-au';
import Tooltip from '../Tooltip';
import { isIE, setElementFocusInIE, keyboard } from '@platform/api';
import { getSysFieldid, getDatetimeFormat } from '@platform/api';

require('bee-datepicker/build/DatePicker.css');
require('./index.less');

if (localeLang === 'simpchn') {
    moment.locale('zh-cn');
} else if (localeLang === 'english') {
    moment.locale('en');
} else if (localeLang === 'tradchn') {
    moment.locale('zh-tw');
} else {
    moment.locale(`${localeLang}`);
}

const { isKeyboard, isArrowKeyDown, KeyCode, isComboKeyboard } = keyboard;

class DatePicker extends Component {
    constructor(props) {
        super(props);
        this.opened = false;
        this.state = {
            localeLang: 'simpchn',
            // open: this.props.datepickerOpen || false
        };
    }

    UNSAFE_componentWillMount() {
        this.setState({ localeLang });
        window.addEventListener('mousedown', this.close, false);
    }

    // componentWillReceiveProps(nextProps) {
    //     this.setState({
    //         // 取上一次的狀態  by bbqin
    //         open:
    //             nextProps.datepickerOpen === undefined
    //                 ? this.state.open
    //                 : nextProps.datepickerOpen
    //     });
    // }
    componentWillUnmount() {
        // 移除document事件
        window.removeEventListener('mousedown', this.close);
        this.dateInput = null;
    }

    componentDidMount() {
        // 做下自動聚焦
        let { tableOpen, autoFocus } = this.props;
        if (autoFocus && this.select && tableOpen) {
            let elem = this.select.querySelector('input'); // 获取到底层的input
            isIE() ? setElementFocusInIE(elem) : elem && elem.focus();
        }
    }

    componentDidUpdate() {
        // 做下自動聚焦
        let { tableOpen, autoFocus } = this.props;
        if (autoFocus && this.select && tableOpen && this.changeValFromPanelSelect === false) {
            let elem = this.select.querySelector('input'); // 获取到底层的input
            isIE() ? setElementFocusInIE(elem) : elem && elem.focus();
        }
    }

    close = e => {
        const { onBlur, value } = this.props;
        // 当在面板里的时候做下判断 -- by bbqin
        let picerPanel = document.querySelector('.rc-calendar.nc-input');
        // 判断当前组件是否被聚焦 有两种情况  情况一 面板弹开  情况二  input 聚焦
        let inputDom = this.select.querySelector('input');
        let focused = document.activeElement === inputDom || this.opened;
        if (
            focused &&
            this.select &&
            !this.select.contains(e.target) &&
            !(picerPanel && picerPanel.contains(e.target))
        ) {
            typeof onBlur === 'function' && onBlur(value);
            this.opened = false;
        }
    };

    onClick = e => {
        this.props.onClick && this.props.onClick(e);
        // this.setState({
        //     open:
        //         this.props.datepickerOpen == undefined ? true : this.state.open
        // });
        // 添加一个状态来区分是否时鼠标和tab操作  by bbqin
        this.clicked = true;
    };

    /**
      * 添加一个关闭时  调用 onBlur事件 bbqin
      */
    onOpenChangeInTable = (isOpen, val, formatValue) => {
        const { onBlur, value, onOpenChange, tableOpen } = this.props;
        this.open = isOpen;
        //ctrl esc 快捷键关闭时不触发表格的blur事件
        if (!isOpen && tableOpen && (this.ctrlKeyDown !== true && !isKeyboard('esc', window.event))) {
            typeof onBlur === 'function' && onBlur(value);
        }

        if (isOpen === false && this.select) {
            let elem = this.select.querySelector('input'); // 获取到底层的input
            isIE() ? setElementFocusInIE(elem) : elem && elem.focus();
        }

        onOpenChange && onOpenChange(isOpen, val, formatValue);

        this.ctrlKeyDown = false;
    };

    // 添加 onOpenChange  来控制关闭时重新聚焦  --bbqin
    onOpenChange = (isOpen, value, formatValue) => {
        // 记录一下open状态给 其他人用
        this.open = isOpen;

        let props = this.props;
        // console.log(this.clicked, this.state.open, this.dateInput);
        // 目前自动聚焦还有些问题  主要是点击其他表单元素时应该聚焦为其他元素
        if (isOpen === false && this.select) {
            let elem = this.select.querySelector('input'); // 获取到底层的input
            isIE() ? setElementFocusInIE(elem) : elem && elem.focus();
        }
        // 关闭之后认为  clicked为false  加这个属性时为了不影响原来的鼠标鼠标操作
        if (isOpen === false) {
            this.clicked = false;
        }
        // 这里需要调用一下外部的编辑前事件   目前的问题是抛出的对象和click中不同
        if (isOpen === true) {
            props.onClick && props.onClick(this.dateInput, this.dateInput);
        }
        this.opened = isOpen;
        props.onOpenChange && props.onOpenChange(isOpen, value, formatValue);
    };

    // keyDown
    keyDownHandler = e => {
        let { onEnter, onBlur, onKeyDown, renderInTable } = this.props;

        onKeyDown && onKeyDown(e, this.dateInputWrap, this.open);
        // 只有一個  e對象  不過應該夠用了
        // enter 键
        if (isKeyboard('enter', e) && this.open !== true) {
            // 不加阻止默認事件  會導致
            e.stopPropagation();
            e.preventDefault();
            let value = this.props.value;
            if (checkFuntionValue(value)) {
                value = '';
            }
            typeof onBlur === 'function' && onBlur(value);
            onEnter &&
                onEnter({
                    e,
                    target: this.select,
                    itemType: config.hotKeyDatePicker,
                });
        }

        //按下ctrl键
        if (renderInTable && isKeyboard('ctrl', e) && this.select) {
            //目前按ctrl键关闭时 会触发表格onBlur事件因此在这儿加一个控制，如果是ctrl触发关闭不去调用表格的blur事件
            this.ctrlKeyDown = true;
        }

        if (isArrowKeyDown(e) && this.open === true) {
            this.changeValFromPanelSelect = true;
        } else {
            this.changeValFromPanelSelect = false;
        }
    };

    outInputKeyDownHandler = e => {
        let { hotKeyWithArrow, onBlur, arrowKeyDownEnable } = this.props;

        if (isArrowKeyDown(e) && this.open !== true && !arrowKeyDownEnable) {
            e.stopPropagation();
            e.preventDefault();
            let value = this.props.value;
            if (checkFuntionValue(value)) {
                value = '';
            }
            onBlur && onBlur(value);

            hotKeyWithArrow &&
                hotKeyWithArrow({ e, target: this.select, itemType: config.hotKeyDatePicker });
        }

        this.keyDownHandler(e);
    };

    render() {
        let {
            format = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY.MM.DD', 'YYYY/MM/DD'],
            value,
            showStar,
            onChange,
            MultiTZ = false,
            // disabledDate,
            showTimeFunction,
            placeholder,
            onBlur,
            className,
            fieldid,
            dropdownClassName,
            dateInputPlaceholder,
            tableOpen,
            onClick,
            ...others
        } = this.props;
        let defaultFormat = isArray(format) ? format[0] : format;
        let finalFormat = getDatetimeFormat(defaultFormat);
        // 添加了inputShowValue属性
        let inputShowValue = '';
        if (value && !(String(value).startsWith("#"))) {
            let localLocale = moment(value);
            localLocale.locale('en');//设置局部moment对象，将语种设置为英文
            inputShowValue = localLocale.format(finalFormat);
        }
        let functionValue = value || '';
        if (checkFuntionValue(value)) {
            value = '';
            placeholder = '';
        }

        if (getSysFieldid(fieldid)) {
            dropdownClassName = dropdownClassName ? dropdownClassName + ` fieldid_${fieldid}_calendar` : `fieldid_${fieldid}_calendar`;
        }

        return (
            <div
                className={`u-form-control-wrapper ${this.props.className}`}
                // 工作桌面需要移除
                // onClick={e => {
                //     e.stopPropagation();
                // }}
                ref={dom => {
                    this.select = dom;
                }}
                onKeyDown={e => {
                    // tab键
                    let isTab = isKeyboard('tab', e);
                    let { renderInTable } = this.props;

                    //如果是事件源是日期面板中的input就不做处理
                    if (renderInTable && e.target.classList.contains('rc-calendar-input') && isTab) {
                        this.isPanelTrigger = true;
                        e.stopPropagation(); // 避免冒泡到上层 触发事件
                        return;
                    }

                    // 判断是否键下tab键和shift 键  bbqin
                    if ((isTab && e.shiftKey) || isTab) {
                        setTimeout(() => {
                            // 实际情况下发现 不添加timeout shift+tab 无法跳转
                            // 猜测 可能是 原生shift+tab 事件与当前事件有了执行顺序
                            // console.log("datepicker onblur trigger", this.props.onBlur);
                            this.props.onBlur && this.props.onBlur(value);
                        }, 0);
                    }
                }}
                onBlur={e => {
                    let { renderInTable } = this.props;
                    //如果是事件源是日期面板中的input就不做处理  避免关闭弹窗
                    if (renderInTable && e.target.classList.contains('rc-calendar-input') && this.isPanelTrigger) {
                        e.stopPropagation();
                    }
                    this.isPanelTrigger = false;
                }}

                onKeyUp={e => {
                    let { renderInTable } = this.props;
                    if (this.ctrlKeyDown && isKeyboard('ctrl', e) && renderInTable && !isComboKeyboard(e)) {
                        let elem = this.select.querySelector('input');
                        elem && elem.click();
                    }
                    this.ctrlKeyDown = false;
                }}
            >
                {showStar ? <span className="datepicker-input-required-tag">*</span> : ''}
                <div style={{ position: 'relative' }} fieldid={getSysFieldid(fieldid)}>
                    <OriginDatePicker
                        // 解决弹开面板时  按tab键关闭了面板的问题
                        inputTabKeyOpen={true}
                        className={`nc-input DatePickerNoTimeZone ${className}`}
                        dropdownClassName={dropdownClassName + ' nc-calendar'}
                        format={format}
                        locale={locale}
                        value={value ? moment(value) : null}
                        showToday={false}
                        placeholder={placeholder}
                        // disabledDate={(current, next) => {
                        // 	this.props.disabledDate && this.props.disabledDate(current, next, moment);
                        // }}
                        inputShowValue={inputShowValue}
                        renderIcon={this.props.renderIcon}
                        onChange={v => {
                            if (MultiTZ) {
                                this.props.onChange && this.props.onChange(v);
                            } else {
                                this.props.onChange &&
                                    this.props.onChange(!v ? v : v.format(isArray(format) ? format[0] : format));
                                // this.props.onChange(!v ? v : v.format(isArray(format) ? format[0] : "YYYY-MM-DD"));
                            }
                            // 升级到2.3.20  blur 会导致操作左右切换时 自动关闭
                            !tableOpen && onBlur && onBlur(v);
                        }}
                        renderFooter={() => getDateFunNode(functionValue, onChange, showTimeFunction,this.props.hiddenFunList)}
                        dateInputPlaceholder={dateInputPlaceholder || 'YYYYMMDD'}
                        renderError={() => (
                            <Tooltip
                                visible={true}
                                className="datepicker-tooltip"
                                placement="top"
                                overlay={`请按如下格式输入有效日期：${dateInputPlaceholder || 'YYYYMMDD'}`}
                            >
                                <span style={{ position: 'absolute', left: '125px' }} />
                            </Tooltip>
                        )}
                        {...others}
                        // onClick={this.onClick}
                        ref={dateInput => {
                            this.dateInput = dateInput; // 获取到组件对象 -- bbqin
                        }}
                        // open={this.state.open}
                        onOpenChange={tableOpen ? this.onOpenChangeInTable : this.onOpenChange}
                        tableOpen={tableOpen}
                        outInputKeydown={this.outInputKeyDownHandler}
                        onKeyDown={this.keyDownHandler}
                    />
                    {getTimeFunctionLabel(functionValue, showTimeFunction)}
                </div>
            </div>
        );
    }
}
DatePicker.defaultProps = {
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
    showClose: false,
};

export default DatePicker;
